"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetHubspotInstallationUrlQuery = void 0;

var _EmptyGatewayApi = require("../../EmptyGatewayApi");

var hubspotInstallation = _EmptyGatewayApi.emptyGatewayApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getHubspotInstallationUrl: build.query({
        query: function query() {
          return "/marketing/hubspot/integrations/authorization-url";
        }
      })
    };
  }
});

var useGetHubspotInstallationUrlQuery = hubspotInstallation.useGetHubspotInstallationUrlQuery;
exports.useGetHubspotInstallationUrlQuery = useGetHubspotInstallationUrlQuery;